// extracted by mini-css-extract-plugin
export default {"credit_term_button_block":"CreditTermRateButtonBlock_credit_term_button_block__GRN4X"};